import { useMemo } from 'react'
import { useSelectContext } from './use-select.ts'

export const SelectValues = <ValueType extends string = string>() => {
  const { placeholder, value, allOptions } = useSelectContext<ValueType>()
  const label = useMemo(
    () => allOptions.find((o) => o.value === value)?.label,
    [allOptions, value]
  )

  if (!label) {
    return placeholder ? (
      <span className="text-placeholder">{placeholder}</span>
    ) : (
      <span />
    )
  }

  return <span className="truncate">{label}</span>
}
